export const phonemeMap = {
  "ai": {
    "sound": "eye",
    "description": "like seeing 'eye to eye'"
  },
  "an": {
    "sound": "ahn",
    "description": "sounds like 'ahn', rhymes with 'flan'"
  },
  "ang": {
    "sound": "ahng",
    "description": "rhymes with 'song'"
  },
  "ao": {
    "sound": "ow",
    "description": "rhymes with 'how'"
  },
  "ba": {
    "sound": "bah",
    "description": "like 'bah' as in 'bah humbug'"
  },
  "bai": {
    "sound": "bye",
    "description": "just like 'bye' in English"
  },
  "ban": {
    "sound": "bahn",
    "description": "sounds like 'bahn', rhymes with 'flan'"
  },
  "bang": {
    "sound": "bahng",
    "description": "similar to 'bong' in 'bongos'"
  },
  "bao": {
    "sound": "bow",
    "description": "like to 'bow one's head'"
  },
  "bei": {
    "sound": "bay",
    "description": "like 'bay' as in San Francisco Bay"
  },
  "ben": {
    "sound": "bun",
    "description": "like 'bun' as in hamburger bun"
  },
  "beng": {
    "sound": "bung",
    "description": "sounds like 'bung' in 'bungalow'"
  },
  "bi": {
    "sound": "bee",
    "description": "like to be or not to be"
  },
  "bian": {
    "sound": "bee-yen",
    "description": "sounds like 'bee-yen'"
  },
  "bin": {
    "sound": "bean",
    "description": "sounds like 'bean', the food"
  },
  "bing": {
    "sound": "bing",
    "description": "like 'bing' as in 'bingo'",
  },
  "bo": {
    "sound": "bwoh",
    "description": "sounds like 'bwoh', ends with an open o sound"
  },
  "bu": {
    "sound": "boo",
    "description": "like 'boo' to scare someone"
  },
  "ca": {
    "sound": "tsah",
    "description": "sounds like 'tsah', rhymes with 'saw'"
  },
  "cai": {
    "sound": "tsigh",
    "description": "sounds like 'tsigh', rhymes with 'sigh'"
  },
  "can": {
    "sound": "tsahn",
    "description": "sounds like 'ts-ahn', rhymes with 'flan'"
  },
  "cang": {
    "sound": "tsahng",
    "description": "sounds like 'ts-ahng', rhymes with 'song'"
  },
  "cao": {
    "sound": "tsow",
    "description": "sounds like 'ts-ow', rhymes with 'cow'"
  },
  "ce": {
    "sound": "tsuh",
    "description": "sounds like 'ts-uh', rhymes with 'uh'"
  },
  "cen": {
    "sound": "tsun",
    "description": "sounds like 'ts-un', rhymes with 'sun'"
  },
  "ceng": {
    "sound": "tsung",
    "description": "sounds like 'ts-ung', rhymes with 'sung'"
  },
  "cha": {
    "sound": "chah",
    "description": "like 'cha-cha' dance"
  },
  "chai": {
    "sound": "chigh",
    "description": "like chai tea"
  },
  "chan": {
    "sound": "chahn",
    "description": "sounds like 'ch-ahn', rhymes with 'flan'"
  },
  "chang": {
    "sound": "chahng",
    "description": "sounds like 'ch-ahng', rhymes with 'song'"
  },
  "chao": {
    "sound": "chow",
    "description": "sounds like 'chow', like food"
  },
  "che": {
    "sound": "chuh",
    "description": "sounds like 'ch-uh', rhymes with 'uh'"
  },
  "chen": {
    "sound": "chun",
    "description": "sounds like 'ch-un', rhymes with 'sun'"
  },
  "cheng": {
    "sound": "chung",
    "description": "sounds like 'ch-ung', rhymes with 'sung'"
  },
  "chi": {
    "sound": "chur",
    "description": "sounds like 'chur', rhymes with 'her'"
  },
  "chong": {
    "sound": "chong",
    "description": "sounds like 'ch-ong', rhymes with 'song'"
  },
  "chou": {
    "sound": "choh",
    "description": "sounds like 'choh', rhymes with 'show'"
  },
  "chu": {
    "sound": "choo",
    "description": "sounds like 'choo', like a 'choo-choo' train"
  },
  "chuai": {
    "sound": "chwigh",
    "description": "sounds like 'ch-why', rhymes with 'why'"
  },
  "chuan": {
    "sound": "chwahn",
    "description": "sounds like 'ch-wahn', rhymes with 'flan'"
  },
  "chuang": {
    "sound": "chwahng",
    "description": "sounds like 'ch-wahng', rhymes with 'song'"
  },
  "chui": {
    "sound": "chway",
    "description": "sounds like 'ch-way', rhymes with 'way'"
  },
  "chun": {
    "sound": "chwun",
    "description": "sounds like 'ch-wun', rhymes with 'moon'"
  },
  "chuo": {
    "sound": "chwoh",
    "description": "sounds like 'chwoh', ends with an open o sound"
  },
  "ci": {
    "sound": "ts",
    "description": "just the ts sound, 'ts'"
  },
  "cong": {
    "sound": "tsong",
    "description": "sounds like 'song' with a t in front, 'tsong'"
  },
  "cou": {
    "sound": "tsoh",
    "description": "sounds like 'so' with a t in front, 'tso'"
  },
  "cu": {
    "sound": "tsoo",
    "description": "starts with ts sound, rhymes with 'zoo'"
  },
  "cuan": {
    "sound": "tswahn",
    "description": "sounds like 'tswahn'"
  },
  "cui": {
    "sound": "tsway",
    "description": "sounds like 'tsway'"
  },
  "cun": {
    "sound": "tswun",
    "description": "starts with ts sound then rhymes with 'moon'"
  },
  "cuo": {
    "sound": "tswoh",
    "description": "sounds like 'tswoh', ends with an open o sound"
  },
  "da": {
    "sound": "dah",
    "description": "like 'ta-da!'"
  },
  "dai": {
    "sound": "digh",
    "description": "rhymes with 'sigh'"
  },
  "dan": {
    "sound": "dahn",
    "description": "sounds like 'dahn', rhymes with 'upon'"
  },
  "dang": {
    "sound": "dahng",
    "description": "rhymes with 'song'"
  },
  "dao": {
    "sound": "dow",
    "description": "rhymes with 'how'"
  },
  "de": {
    "sound": "duh",
    "description": "just like the expression 'duh'"
  },
  "dei": {
    "sound": "day",
    "description": "exactly like 'day' of the week"
  },
  "den": {
    "sound": "dun",
    "description": "like 'done' but shorter"
  },
  "deng": {
    "sound": "dung",
    "description": "rhymes with 'sung'"
  },
  "di": {
    "sound": "dee",
    "description": "like the letter D"
  },
  "dian": {
    "sound": "dee-yen",
    "description": "sounds like 'dee-yen'"
  },
  "diao": {
    "sound": "dee-ow",
    "description": "sounds like 'dee-ow'"
  },
  "die": {
    "sound": "dee-eh",
    "description": "sounds like 'dee-eh'"
  },
  "ding": {
    "sound": "ding",
    "description": "like the bell sound 'ding'"
  },
  "diu": {
    "sound": "dee-oh",
    "description": "sounds like 'dee-oh', rhymes with 'show'"
  },
  "dong": {
    "sound": "dong",
    "description": "like the bell sound, 'dong'"
  },
  "dou": {
    "sound": "doh",
    "description": "like 'dough' for bread"
  },
  "du": {
    "sound": "doo",
    "description": "like 'do' as in to-do list"
  },
  "duan": {
    "sound": "dwahn",
    "description": "sounds like 'dwahn'"
  },
  "dui": {
    "sound": "dway",
    "description": "sounds like 'd-way', rhymes with 'way'"
  },
  "dun": {
    "sound": "dwun",
    "description": "sounds like 'd-wun', rhymes with 'moon'"
  },
  "duo": {
    "sound": "dwoh",
    "description": "sounds like 'dwoh', ends with an open o sound"
  },
  "e": {
    "sound": "uh",
    "description": "just like the expression 'uh'"
  },
  "ei": {
    "sound": "ay",
    "description": "just like the letter A"
  },
  "en": {
    "sound": "un",
    "description": "rhymes with 'done'"
  },
  "eng": {
    "sound": "ung",
    "description": "rhymes with 'sung'"
  },
  "er": {
    "sound": "arr",
    "description": "like a pirate saying 'arr'"
  },
  "fa": {
    "sound": "fah",
    "description": "like the beginning of 'father'"
  },
  "fan": {
    "sound": "fahn",
    "description": "sounds like 'fahn', rhymes with 'flan'"
  },
  "fang": {
    "sound": "fahng",
    "description": "rhymes with 'song'"
  },
  "fei": {
    "sound": "fay",
    "description": "just like the name 'Fay'"
  },
  "fen": {
    "sound": "fun",
    "description": "just like 'having fun'"
  },
  "feng": {
    "sound": "fung",
    "description": "rhymes with 'sung'"
  },
  "fo": {
    "sound": "fwoh",
    "description": "sounds like 'f-woh', ends with an open o sound"
  },
  "fou": {
    "sound": "foh",
    "description": "like 'friend or foe'"
  },
  "fu": {
    "sound": "foo",
    "description": "just like the 'foo' in kung fu"
  },
  "ga": {
    "sound": "gah",
    "description": "like the expression 'gah!'"
  },
  "gai": {
    "sound": "guy",
    "description": "like 'that guy!'"
  },
  "gan": {
    "sound": "gahn",
    "description": "sounds like 'gahn', rhymes with 'flan'"
  },
  "gang": {
    "sound": "gahng",
    "description": "rhymes with 'song'"
  },
  "gao": {
    "sound": "gow",
    "description": "rhymes with 'how'"
  },
  "ge": {
    "sound": "guh",
    "description": "like the start of the word 'good'"
  },
  "gei": {
    "sound": "gay",
    "description": "just like the word 'gay'"
  },
  "gen": {
    "sound": "gun",
    "description": "just like the word 'gun'"
  },
  "geng": {
    "sound": "gung",
    "description": "like the 'gung' in gung ho"
  },
  "gong": {
    "sound": "gong",
    "description": "just like the instrument 'gong'"
  },
  "gou": {
    "sound": "goh",
    "description": "rhymes with 'show'"
  },
  "gu": {
    "sound": "goo",
    "description": "just like the word 'goo'"
  },
  "gua": {
    "sound": "gwah",
    "description": "like the start of the word 'guacamole'"
  },
  "guai": {
    "sound": "gwigh",
    "description": "starts with g and then the word 'why'"
  },
  "guan": {
    "sound": "gwahn",
    "description": "like in the word 'iguana'"
  },
  "guang": {
    "sound": "gwahng",
    "description": "starts with a gw sound, and then rhymes with 'song'"
  },
  "gui": {
    "sound": "gway",
    "description": "starts with g and then says 'way'"
  },
  "gun": {
    "sound": "gwun",
    "description": "sounds like 'gw-un', rhymes with 'moon'"
  },
  "guo": {
    "sound": "gwoh",
    "description": "sounds like 'gwoh', ends with an open o sound"
  },
  "ha": {
    "sound": "hah",
    "description": "like laughing 'ha ha ha'"
  },
  "hai": {
    "sound": "high",
    "description": "just like the word 'high'"
  },
  "han": {
    "sound": "hahn",
    "description": "sounds like 'hahn', rhymes with 'upon'"
  },
  "hang": {
    "sound": "hahng",
    "description": "rhymes with 'song'"
  },
  "hao": {
    "sound": "how",
    "description": "just like the word 'how'"
  },
  "he": {
    "sound": "huh",
    "description": "like saying 'huh?' in confusion"
  },
  "hei": {
    "sound": "hay",
    "description": "just like 'hay' for horses"
  },
  "hen": {
    "sound": "hun",
    "description": "like 'hun' as in honey"
  },
  "heng": {
    "sound": "hung",
    "description": "just like the word 'hung'"
  },
  "hong": {
    "sound": "hong",
    "description": "rhymes with 'song'"
  },
  "hou": {
    "sound": "hoh",
    "description": "like Santa's 'ho ho ho' laugh"
  },
  "hu": {
    "sound": "hoo",
    "description": "like an owl saying 'hoo'"
  },
  "hua": {
    "sound": "hwah",
    "description": "sounds like 'hw-ah'"
  },
  "huai": {
    "sound": "hwigh",
    "description": "sounds like 'h-why', rhymes with 'why'"
  },
  "huan": {
    "sound": "hwahn",
    "description": "sounds like 'hw-ahn'"
  },
  "huang": {
    "sound": "hwahng",
    "description": "sounds like 'hw-ahng', rhymes with 'song'"
  },
  "hui": {
    "sound": "hway",
    "description": "sounds like 'h-way'"
  },
  "hun": {
    "sound": "hwun",
    "description": "sounds like 'hw-un, rhymes with 'moon'"
  },
  "huo": {
    "sound": "hwoh",
    "description": "sounds like 'hw-oh', ends with an open o sound"
  },
  "ji": {
    "sound": "jee",
    "description": "just like the letter G"
  },
  "jia": {
    "sound": "jee-ah",
    "description": "sounds like 'jee-ah'"
  },
  "jian": {
    "sound": "jee-yen",
    "description": "sounds like 'jee-yen'"
  },
  "jiang": {
    "sound": "jee-ahng",
    "description": "sounds like 'jee-ahng, rhymes with 'song'"
  },
  "jiao": {
    "sound": "jee-ow",
    "description": "sounds like 'jee-ow'"
  },
  "jie": {
    "sound": "jee-eh",
    "description": "sounds like 'jee-eh'"
  },
  "jin": {
    "sound": "jean",
    "description": "just like the word 'jean' as in blue jeans"
  },
  "jing": {
    "sound": "jing",
    "description": "like 'jingle'"
  },
  "jiu": {
    "sound": "jee-oh",
    "description": "sounds like 'jee-oh', rhymes with 'show'"
  },
  "ju": {
    "sound": "joo",
    "description": "like the start of the word 'juniper'"
  },
  "juan": {
    "sound": "jwen",
    "description": "sounds like 'jwen'"
  },
  "jue": {
    "sound": "jweh",
    "description": "sounds like 'jweh'"
  },
  "jun": {
    "sound": "joon",
    "description": "similar to the month 'June'"
  },
  "ka": {
    "sound": "kah",
    "description": "like the expression 'ka-pow!'"
  },
  "kai": {
    "sound": "kigh",
    "description": "rhymes with 'sigh'"
  },
  "kan": {
    "sound": "kahn",
    "description": "sounds like 'kahn', rhymes with 'upon'"
  },
  "kang": {
    "sound": "kahng",
    "description": "rhymes with 'song'"
  },
  "kao": {
    "sound": "kow",
    "description": "rhymes with 'how'"
  },
  "ke": {
    "sound": "kuh",
    "description": "sounds like 'kuh', like the start of the word 'cut'"
  },
  "kei": {
    "sound": "kay",
    "description": "just like the letter K"
  },
  "ken": {
    "sound": "kun",
    "description": "rhymes with 'done'"
  },
  "keng": {
    "sound": "kung",
    "description": "just like the 'kung' in kung fu"
  },
  "kong": {
    "sound": "kong",
    "description": "just like 'King Kong'"
  },
  "kou": {
    "sound": "koh",
    "description": "rhymes with 'show'"
  },
  "ku": {
    "sound": "koo",
    "description": "just like the word 'coup'"
  },
  "kua": {
    "sound": "kwah",
    "description": "sounds like 'kw-ah'"
  },
  "kuai": {
    "sound": "kwigh",
    "description": "sounds like 'kw-why', rhymes with 'why'"
  },
  "kuan": {
    "sound": "kwahn",
    "description": "sounds like 'kw-ahn', rhymes with 'upon'"
  },
  "kuang": {
    "sound": "kwahng",
    "description": "sounds like 'kw-ahng', rhymes with 'song'"
  },
  "kui": {
    "sound": "kway",
    "description": "sounds like 'kw-way', rhymes with 'way'"
  },
  "kun": {
    "sound": "kwun",
    "description": "sounds like 'koo-wun, rhymes with 'moon'"
  },
  "kuo": {
    "sound": "kwoh",
    "description": "sounds like 'kwoh', ends with an open o sound"
  },
  "la": {
    "sound": "lah",
    "description": "like singing 'la la la'"
  },
  "lai": {
    "sound": "ligh",
    "description": "rhymes with 'sigh'"
  },
  "lan": {
    "sound": "lahn",
    "description": "sounds like 'lawn' but not quite such a long sound"
  },
  "lang": {
    "sound": "lahng",
    "description": "rhymes with 'song'"
  },
  "lao": {
    "sound": "low",
    "description": "rhymes with 'how'"
  },
  "le": {
    "sound": "luh",
    "description": "like the start of the word 'love'"
  },
  "lei": {
    "sound": "lay",
    "description": "like 'to lay down'"
  },
  "leng": {
    "sound": "lung",
    "description": "just like the word 'lung'"
  },
  "li": {
    "sound": "lee",
    "description": "just like the name 'Lee'"
  },
  "lia": {
    "sound": "lee-ah",
    "description": "sounds like 'lee-ah'"
  },
  "lian": {
    "sound": "lee-yen",
    "description": "sounds like 'lee-yen'"
  },
  "liang": {
    "sound": "lee-ahng",
    "description": "sounds like 'lee-ahng, rhymes with 'song'"
  },
  "liao": {
    "sound": "lee-ow",
    "description": "sounds like 'lee-ow'"
  },
  "lie": {
    "sound": "lee-eh",
    "description": "sounds like 'lee-eh'"
  },
  "lin": {
    "sound": "lean",
    "description": "just like the word 'lean'"
  },
  "ling": {
    "sound": "ling",
    "description": "like 'to linger'"
  },
  "liu": {
    "sound": "lee-oh",
    "description": "sounds like 'lee-oh', rhymes with 'show'"
  },
  "long": {
    "sound": "long",
    "description": "just like the word 'long'"
  },
  "lou": {
    "sound": "loh",
    "description": "rhymes with 'show'"
  },
  "lu": {
    "sound": "loo",
    "description": "rhymes with 'zoo'"
  },
  "luan": {
    "sound": "lwahn",
    "description": "sounds like 'lw-ahn', rhymes with 'upon'"
  },
  "lue": {
    "sound": "loo-eh",
    "description": "sounds like 'loo-eh'"
  },
  "lun": {
    "sound": "loon",
    "description": "sounds like 'loon'"
  },
  "luo": {
    "sound": "lwoh",
    "description": "sounds like 'lwoh', ends with an open o sound"
  },
  "lv": {
    "sound": "lv",
    "description": "starts with l, then has the umlaut sound, like 'adieu'"
  },
  "ma": {
    "sound": "mah",
    "description": "like 'ma and pa'"
  },
  "mai": {
    "sound": "migh",
    "description": "rhymes with 'sigh'"
  },
  "man": {
    "sound": "mahn",
    "description": "sounds like 'mahn', rhymes with 'flan'"
  },
  "mang": {
    "sound": "mahng",
    "description": "rhymes with 'song'"
  },
  "mao": {
    "sound": "mow",
    "description": "rhymes with 'how'"
  },
  "me": {
    "sound": "muh",
    "description": "like the start of the word 'mother'"
  },
  "mei": {
    "sound": "may",
    "description": "just like the month 'May'"
  },
  "men": {
    "sound": "mun",
    "description": "sounds like 'mun', rhymes with 'done'"
  },
  "meng": {
    "sound": "mung",
    "description": "rhymes with 'sung'"
  },
  "mi": {
    "sound": "mee",
    "description": "like the musical note 'mi'"
  },
  "mian": {
    "sound": "mee-yen",
    "description": "starts with 'mee' and then says the letter N"
  },
  "miao": {
    "sound": "mee-ow",
    "description": "sounds like 'mee-ow'"
  },
  "mie": {
    "sound": "mee-eh",
    "description": "starts with 'mee' and then says 'eh'"
  },
  "min": {
    "sound": "mean",
    "description": "just like the word 'mean'"
  },
  "ming": {
    "sound": "ming",
    "description": "like in 'mingle'"
  },
  "miu": {
    "sound": "mee-oh",
    "description": "sounds like 'mee-oh', rhymes with 'show'"
  },
  "mo": {
    "sound": "mwoh",
    "description": "sounds like 'mwoh', ends with an open o sound"
  },
  "mou": {
    "sound": "moh",
    "description": "rhymes with 'show'"
  },
  "mu": {
    "sound": "moo",
    "description": "sounds like 'moo'"
  },
  "na": {
    "sound": "nah",
    "description": "sounds like 'nah' as in 'no way'"
  },
  "nai": {
    "sound": "nigh",
    "description": "rhymes with 'sigh'"
  },
  "nan": {
    "sound": "nahn",
    "description": "sounds like 'nah' but add a soft n at the end"
  },
  "nang": {
    "sound": "nahng",
    "description": "rhymes with 'song'"
  },
  "nao": {
    "sound": "now",
    "description": "just like the word 'now'"
  },
  "ne": {
    "sound": "nuh",
    "description": "like the start of the word 'nothing'"
  },
  "nei": {
    "sound": "nay",
    "description": "like 'ay or nay'"
  },
  "nen": {
    "sound": "nun",
    "description": "just like the word 'nun'"
  },
  "neng": {
    "sound": "nung",
    "description": "rhymes with 'sung'"
  },
  "ni": {
    "sound": "nee",
    "description": "like the body part 'knee'"
  },
  "nian": {
    "sound": "nee-yen",
    "description": "sounds like 'nee-yen'"
  },
  "niang": {
    "sound": "nee-ahng",
    "description": "sounds like 'nee-ahng, rhymes with 'song'"
  },
  "niao": {
    "sound": "nee-ow",
    "description": "sounds like 'nee-ow'"
  },
  "nie": {
    "sound": "nee-eh",
    "description": "sounds like 'nee-eh'"
  },
  "nin": {
    "sound": "nean",
    "description": "rhymes with 'dean'"
  },
  "ning": {
    "sound": "ning",
    "description": "rhymes with 'sing'"
  },
  "niu": {
    "sound": "nee-oh",
    "description": "sounds like 'nee-oh', rhymes with 'show'"
  },
  "nong": {
    "sound": "nong",
    "description": "rhymes with 'song'"
  },
  "nou": {
    "sound": "noh",
    "description": "rhymes with 'show'"
  },
  "nu": {
    "sound": "noo",
    "description": "just like the word 'new'"
  },
  "nuan": {
    "sound": "noo-ahn",
    "description": "sounds like 'noo-ahn', rhymes with 'flan'"
  },
  "nue": {
    "sound": "noo-eh",
    "description": "sounds like 'noo-eh'"
  },
  "nun": {
    "sound": "nwun",
    "description": "sounds like 'n-wun, rhymes with 'moon'"
  },
  "nuo": {
    "sound": "nwoh",
    "description": "sounds like 'n-woh', ends with an open o sound"
  },
  "nv": {
    "sound": "nuu",
    "description": "starts with n, then has the umlaut sound, like 'adieu'"
  },
  "ou": {
    "sound": "oh",
    "description": "rhymes with 'show'"
  },
  "pa": {
    "sound": "pah",
    "description": "like 'ma' and 'pa'"
  },
  "pai": {
    "sound": "pigh",
    "description": "like 'apple pie'"
  },
  "pan": {
    "sound": "pahn",
    "description": "sounds like 'pahn', rhymes with 'flan'"
  },
  "pang": {
    "sound": "pahng",
    "description": "rhymes with 'song'"
  },
  "pao": {
    "sound": "pow",
    "description": "rhymes with 'how'"
  },
  "pei": {
    "sound": "pay",
    "description": "like 'pay it forward'"
  },
  "pen": {
    "sound": "pun",
    "description": "like 'to make a pun'"
  },
  "peng": {
    "sound": "pung",
    "description": "rhymes with 'sung'"
  },
  "pi": {
    "sound": "pee",
    "description": "like the letter P"
  },
  "pian": {
    "sound": "pee-yen",
    "description": "sounds like 'pee-yen'"
  },
  "piao": {
    "sound": "pee-ow",
    "description": "sounds like 'pee-ow'"
  },
  "pie": {
    "sound": "pee-eh",
    "description": "starts with the letter P and then says 'eh'"
  },
  "pin": {
    "sound": "peen",
    "description": "rhymes with 'seen'"
  },
  "ping": {
    "sound": "ping",
    "description": "just like 'ping pong'"
  },
  "po": {
    "sound": "pwoh",
    "description": "sounds like 'pwoh', ends with an open o sound"
  },
  "pou": {
    "sound": "poh",
    "description": "rhymes with 'show'"
  },
  "pu": {
    "sound": "poo",
    "description": "rhymes with 'zoo'"
  },
  "qi": {
    "sound": "chee",
    "description": "like 'cheese' without the 's'"
  },
  "qia": {
    "sound": "chee-ah",
    "description": "sounds like 'chee-ah'"
  },
  "qian": {
    "sound": "chee-yen",
    "description": "sounds like 'chee-yen'"
  },
  "qiang": {
    "sound": "chee-ahng",
    "description": "sounds like 'chee-ahng, rhymes with 'song'"
  },
  "qiao": {
    "sound": "chee-ow",
    "description": "sounds like 'chee-ow'" 
  },
  "qie": {
    "sound": "chee-eh",
    "description": "sounds like 'chee-eh'"
  },
  "qin": {
    "sound": "cheen",
    "description": "rhymes with 'seen'"
  },
  "qing": {
    "sound": "chee-ing",
    "description": "sounds like 'chee-ing'"
  },
  "qiu": {
    "sound": "chee-oh",
    "description": "sounds like 'chee-oh', rhymes with 'show'"
  },
  "qu": {
    "sound": "choo",
    "description": "starts with the ch sound, then has an umlaut like adieu"
  },
  "quan": {
    "sound": "chwen",
    "description": "sounds like 'chwen'"
  },
  "que": {
    "sound": "chweh",
    "description": "sounds like 'chw-eh'"
  },
  "qun": {
    "sound": "choon",
    "description": "starts with 'chew' and then rhymes with 'moon'"
  },
  "ran": {
    "sound": "rahn",
    "description": "sounds like 'rahn', rhymes with 'flan'"
  },
  "rang": {
    "sound": "rahng",
    "description": "rhymes with 'song'"
  },
  "rao": {
    "sound": "row",
    "description": "rhymes with 'how'"
  },
  "re": {
    "sound": "ruh",
    "description": "like the start of the word 'run'"
  },
  "ren": {
    "sound": "run",
    "description": "just like 'to run', rhymes with 'done'"
  },
  "reng": {
    "sound": "rung",
    "description": "like the rung of a ladder"
  },
  "ri": {
    "sound": "rur",
    "description": "just the r sound, rhymes with 'her'"
  },
  "rong": {
    "sound": "rong",
    "description": "rhymes with 'song'"
  },
  "rou": {
    "sound": "roh",
    "description": "like ducks in a row"
  },
  "ru": {
    "sound": "roo",
    "description": "rhymes with 'zoo'"
  },
  "ruan": {
    "sound": "rwahn",
    "description": "sounds like 'rwahn', rhymes with 'flan'"
  },
  "rui": {
    "sound": "rway",
    "description": "sounds like 'roo-way'"
  },
  "run": {
    "sound": "rwun",
    "description": "sounds like 'roo-wun, rhymes with 'moon'"
  },
  "ruo": {
    "sound": "rwoh",
    "description": "sounds like 'rwoh', ends with an open o sound"
  },
  "sa": {
    "sound": "sah",
    "description": "rhymes with 'spa'"
  },
  "sai": {
    "sound": "sigh",
    "description": "just like the word 'sigh'"
  },
  "san": {
    "sound": "sahn",
    "description": "sounds like 'sahn', rhymes with 'flan'"
  },
  "sang": {
    "sound": "sahng",
    "description": "rhymes with 'song'"
  },
  "sao": {
    "sound": "sow",
    "description": "rhymes with 'how'"
  },
  "se": {
    "sound": "suh",
    "description": "like the start of the word 'support'"
  },
  "sen": {
    "sound": "sun",
    "description": "just like the word 'sun'"
  },
  "seng": {
    "sound": "sung",
    "description": "just like the word 'sung'"
  },
  "sha": {
    "sound": "shah",
    "description": "like the 'shah' as in the royal title"
  },
  "shai": {
    "sound": "shigh",
    "description": "just like the word 'shy'"
  },
  "shan": {
    "sound": "shahn",
    "description": "sounds like 'shahn', rhymes with 'flan'"
  },
  "shang": {
    "sound": "shahng",
    "description": "sounds like 'shahng', rhymes with 'song'"
  },
  "shao": {
    "sound": "show",
    "description": "rhymes with 'how'"
  },
  "she": {
    "sound": "shuh",
    "description": "sounds like 'shuh', like the start of the word 'should'"
  },
  "shei": {
    "sound": "shay",
    "description": "just like the name 'Shay'"
  },
  "shen": {
    "sound": "shun",
    "description": "sounds like 'shun', rhymes with 'done'"
  },
  "sheng": {
    "sound": "shung",
    "description": "sounds like 'shung', rhymes with 'sung'"
  },
  "shi": {
    "sound": "shur",
    "description": "sounds like 'shur', rhymes with 'her'"
  },
  "shou": {
    "sound": "shoh",
    "description": "sounds like the word 'show'"
  },
  "shu": {
    "sound": "shoo",
    "description": "sounds like 'shoo', rhymes with 'zoo'"
  },
  "shua": {
    "sound": "shwah",
    "description": "sounds like 'shwah'"
  },
  "shuai": {
    "sound": "shwigh",
    "description": "sounds like 'sh-why', rhymes with 'why'"
  },
  "shuan": {
    "sound": "shwahn",
    "description": "sounds like 'shwahn', rhymes with 'flan'"
  },
  "shuang": {
    "sound": "shwahng",
    "description": "sounds like 'shw-ahng', rhymes with 'song'"
  },
  "shui": {
    "sound": "shway",
    "description": "sounds like 'sh-way'"
  },
  "shun": {
    "sound": "shwun",
    "description": "sounds like 'sh-wun, rhymes with 'moon'"
  },
  "shuo": {
    "sound": "shwoh",
    "description": "sounds like 'shwoh', ends with an open o sound"
  },
  "si": {
    "sound": "ss",
    "description": "just the s sound, 'ss'"
  },
  "song": {
    "sound": "song",
    "description": "just like the word 'song'"
  },
  "sou": {
    "sound": "soh",
    "description": "sounds like 'soh', rhymes with 'show'"
  },
  "su": {
    "sound": "soo",
    "description": "rhymes with 'zoo'"
  },
  "suan": {
    "sound": "swahn",
    "description": "sounds like 'swahn', rhymes with 'flan'"
  },
  "sui": {
    "sound": "sway",
    "description": "like 'to sway' back and forth"
  },
  "sun": {
    "sound": "swun",
    "description": "sounds like 'swun, rhymes with 'moon'"
  },
  "suo": {
    "sound": "swoh",
    "description": "sounds like 'swoh', ends with an open o sound"
  },
  "ta": {
    "sound": "tah",
    "description": "like the beginning of 'father'"
  },
  "tai": {
    "sound": "tigh",
    "description": "like a bow tie" 
  },
  "tan": {
    "sound": "tahn",
    "description": "sounds like 'tahn', rhymes with flan"
  },
  "tang": {
    "sound": "tahng",
    "description": "sounds like 'tahng', rhymes with 'song'"
  },
  "tao": {
    "sound": "tow",
    "description": "rhymes with 'how'"
  },
  "te": {
    "sound": "tuh",
    "description": "like the start of the word 'together'"
  },
  "tei": {
    "sound": "tay",
    "description": "sounds like 'tay'"
  },
  "teng": {
    "sound": "tung",
    "description": "rhymes with 'sung'"
  },
  "ti": {
    "sound": "tee",
    "description": "like the letter T"
  },
  "tian": {
    "sound": "tee-yen",
    "description": "sounds like 'tee-yen'"
  },
  "tiao": {
    "sound": "tee-ow",
    "description": "sounds like 'tee-ow'"
  },
  "tie": {
    "sound": "tee-eh",
    "description": "sounds like 'tee-eh'"
  },
  "ting": {
    "sound": "ting",
    "description": "rhymes with 'sing'"
  },
  "tong": {
    "sound": "tong",
    "description": "rhymes with 'song'"
  },
  "tou": {
    "sound": "toh",
    "description": "rhymes with 'show'"
  },
  "tu": {
    "sound": "too",
    "description": "like the number 'two'"
  },
  "tuan": {
    "sound": "twahn",
    "description": "sounds like 'twahn', rhymes with 'flan'"
  },
  "tui": {
    "sound": "tway",
    "description": "sounds like 'tway'"
  },
  "tun": {
    "sound": "twun",
    "description": "sounds like 'twun, rhymes with 'moon'"
  },
  "tuo": {
    "sound": "twoh",
    "description": "sounds like 'twoh', ends with an open o sound"
  },
  "wa": {
    "sound": "wah",
    "description": "like the word 'water'"
  },
  "wai": {
    "sound": "why",
    "description": "like the word 'why'"
  },
  "wan": {
    "sound": "wahn",
    "description": "like in 'wander'"
  },
  "wang": {
    "sound": "wahng",
    "description": "rhymes with 'song'"
  },
  "wei": {
    "sound": "way",
    "description": "like 'way to go!'"
  },
  "wen": {
    "sound": "wun",
    "description": "sounds like the number 'one'"
  },
  "weng": {
    "sound": "wung",
    "description": "rhymes with 'sung'"
  },
  "wo": {
    "sound": "woh",
    "description": "sounds like 'woh', ends with an open o sound"
  },
  "wu": {
    "sound": "woo",
    "description": "like 'woo-hoo!'"
  },
  "xi": {
    "sound": "shee",
    "description": "like 'she' but with a long e sound"
  },
  "xia": {
    "sound": "shee-ah",
    "description": "sounds like 'shee-ah'"
  },
  "xian": {
    "sound": "shee-yen",
    "description": "sounds like 'shee-yen'"
  },
  "xiang": {
    "sound": "shee-ahng",
    "description": "sounds like 'shee-ahng, rhymes with 'song'"
  },
  "xiao": {
    "sound": "shee-ow",
    "description": "sounds like 'shee-ow', rhymes with 'meow'"
  },
  "xie": {
    "sound": "shee-eh",
    "description": "sounds like 'shee-eh'"
  },
  "xin": {
    "sound": "sheen",
    "description": "like the second part of the word 'machine'"
  },
  "xing": {
    "sound": "shee-ing",
    "description": "sounds like 'shee-ing', rhymes with 'sing'"
  },
  "xiong": {
    "sound": "shee-ong",
    "description": "sounds like 'shee-ong, rhymes with 'song'"
  },
  "xiu": {
    "sound": "shee-oh",
    "description": "sounds like 'shee-oh', rhymes with 'show'"
  },
  "xu": {
    "sound": "shoo",
    "description": "starts with the sh sound, then has an umlaut like adieu"
  },
  "xuan": {
    "sound": "shwen",
    "description": "sounds like 'shwen'"
  },
  "xue": {
    "sound": "shoo-eh",
    "description": "sounds like 'shw-eh'"
  },
  "xun": {
    "sound": "shoon",
    "description": "starts with 'shu' and then rhymes with 'moon'"
  },
  "ya": {
    "sound": "yah",
    "description": "like saying 'yeah' in agreement"
  },
  "yai": {
    "sound": "yigh",
    "description": "starts with y and then rhymes with 'sigh'"
  },
  "yan": {
    "sound": "yen",
    "description": "sounds like 'yen'"
  },
  "yang": {
    "sound": "yahng",
    "description": "rhymes with 'song'"
  },
  "yao": {
    "sound": "yow",
    "description": "rhymes with 'how'"
  },
  "ye": {
    "sound": "yeh",
    "description": "sounds like 'yeh'"
  },
  "yi": {
    "sound": "yee",
    "description": "like the letter E"
  },
  "yin": {
    "sound": "yeen",
    "description": "sounds like 'yeen'"
  },
  "ying": {
    "sound": "ying",
    "description": "rhymes with 'sing'"
  },
  "yong": {
    "sound": "yong",
    "description": "rhymes with 'song'"
  },
  "you": {
    "sound": "yoh",
    "description": "like in 'yo-yo'"
  },
  "yu": {
    "sound": "yoo",
    "description": "just like the word 'you'"
  },
  "yuan": {
    "sound": "ywen",
    "description": "sounds like 'ywen'"
  },
  "yue": {
    "sound": "yoo-eh",
    "description": "sounds like 'yu-eh'"
  },
  "yun": {
    "sound": "yoon",
    "description": "rhymes with 'moon'"
  },
  "za": {
    "sound": "zah",
    "description": "like the 'za' in pizza"
  },
  "zai": {
    "sound": "zigh",
    "description": "rhymes with 'sigh'"
  },
  "zan": {
    "sound": "zahn",
    "description": "sounds like 'zahn', rhymes with 'flan'"
  },
  "zang": {
    "sound": "zahng",
    "description": "sounds like 'zahng', rhymes with 'song'"
  },
  "zao": {
    "sound": "zow",
    "description": "rhymes with 'how'"
  },
  "ze": {
    "sound": "zuh",
    "description": "like the 'ze' in pizza"
  },
  "zei": {
    "sound": "zay",
    "description": "rhymes with 'way'"
  },
  "zen": {
    "sound": "zun",
    "description": "rhymes with 'done'"
  },
  "zeng": {
    "sound": "zung",
    "description": "rhymes with 'sung'"
  },
  "zha": {
    "sound": "jah",
    "description": "has a j sound, like 'jaw'"
  },
  "zhai": {
    "sound": "jigh",
    "description": "starts with a j sound and then rhymes with 'sigh'"
  },
  "zhan": {
    "sound": "jahn",
    "description": "sounds like 'jahn', rhymes with 'flan'"
  },
  "zhang": {
    "sound": "jahng",
    "description": "sounds like 'jahng', rhymes with 'song'"
  },
  "zhao": {
    "sound": "jow",
    "description": "sounds like 'jow', rhymes with 'how'"
  },
  "zhe": {
    "sound": "juh",
    "description": "sounds like juh"
  },
  "zhei": {
    "sound": "jay",
    "description": "sounds like the letter J'"
  },
  "zhen": {
    "sound": "jun",
    "description": "sounds like 'j-un', rhymes with 'done'"
  },
  "zheng": {
    "sound": "jung",
    "description": "like 'jung' in 'jungle'"
  },
  "zhi": {
    "sound": "jur",
    "description": "like the start of the word 'jury'"
  },
  "zhong": {
    "sound": "jong",
    "description": "starts with j sound and then rhymes with 'song'"
  },
  "zhou": {
    "sound": "joh",
    "description": "like the name 'Joe'"
  },
  "zhu": {
    "sound": "joo",
    "description": "sounds like 'joo'"
  },
  "zhua": {
    "sound": "jwah",
    "description": "sounds like 'jwah'"
  },
  "zhuai": {
    "sound": "jway",
    "description": "sounds like 'jway'"
  },
  "zhuan": {
    "sound": "jwahn",
    "description": "sounds like 'jwahn', rhymes with 'flan'"
  },
  "zhuang": {
    "sound": "jwahng",
    "description": "sounds like 'jwahng, rhymes with 'song'"
  },
  "zhui": {
    "sound": "jway",
    "description": "sounds like 'jway'"
  },
  "zhun": {
    "sound": "jwun",
    "description": "sounds like 'jwun, rhymes with 'moon'"
  },
  "zhuo": {
    "sound": "jwoh",
    "description": "sounds like 'jwoh', ends with an open o sound"
  },
  "zi": {
    "sound": "zuh",
    "description": "just the z sound, 'zz'"
  },
  "zong": {
    "sound": "tsong",
    "description": "rhymes with 'song'"
  },
  "zou": {
    "sound": "zoh",
    "description": "rhymes with 'show'"
  },
  "zu": {
    "sound": "zoo",
    "description": "just like the word 'zoo'"
  },
  "zuan": {
    "sound": "zwahn",
    "description": "sounds like 'zwahn', rhymes with 'flan'"
  },
  "zui": {
    "sound": "zway",
    "description": "sounds like 'zway'"
  },
  "zun": {
    "sound": "zwun",
    "description": "sounds like 'zwun, rhymes with 'moon'"
  },
  "zuo": {
    "sound": "zwoh",
    "description": "sounds like 'zwoh', ends with an open o sound"
  }
}
